import { Component} from '@angular/core';

@Component({
    selector   : 'my-app',
    template: require('./app.component.html'),
    styles: [require('./app.component.scss')]
})

export class AppComponent {

    constructor() {
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/app.component.ts